export default function useProfilePicture() {
  function handleGetProfilePictureURI(picture: string | undefined | null) {
    const storageUri = process.env.REACT_APP_STORAGE_URI;
    const storageProfilePicUri = `${storageUri}/profile_pictures/`;

    if (picture) {
      return storageProfilePicUri + picture;
    }

    return storageProfilePicUri + "anonymous-profile-image.png";
  }

  return {
    getProfilePictureURI: handleGetProfilePictureURI,
  };
}
